import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'use-memo-one'

import { useTranslation } from '@root/shared/localization'
import { ConfirmDrawer } from '@root/shared/ui-kit'

import { reatomDeleteWallet } from '../../atoms'

import type { WalletModel } from '@root/entities/wallet'
import type { DrawerControlProps } from '@root/shared/ui-kit'

type DeleteWalletDrawerProps = {
  wallet: WalletModel
} & DrawerControlProps

export const DeleteWalletDrawer: React.FC<DeleteWalletDrawerProps> = ({
  wallet,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()

  const deleteModel = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomDeleteWallet({ wallet }),
    [wallet],
  )
  const [deleteWalletState] = useAtom(deleteModel)
  const deleteWallet = useAction(deleteModel.execute)

  return (
    <ConfirmDrawer
      intent="error"
      onConfirm={deleteWallet}
      open={open}
      header={t('wallet.deleting_a_wallet')}
      title={t('wallet.delete_confirmation.subtitle')}
      description={t('wallet.delete_confirmation.description')}
      onOpenChange={onOpenChange}
      busy={deleteWalletState.loading}
      onCancel={() => onOpenChange?.(false)}
    />
  )
}
